import React, { Component } from 'react';

import DescriptiveCard from './DescriptiveCard';
import CustomFieldsCard from './CustomFieldsCard';
import NoteTextBox from './NoteTextBox';
import _ from 'lodash';


export default function DraftParentsGroup(props) {
  const {
    session, draft, onChange, onClick, value, disabled, participantBtn, btnHidden, leader, endSession,
  } = props;

  const isHidden = props.isHidden || {};
  const values = props.values || {};

  if (!(session && draft)) {
    return null;
  }

  return (
    <div key={`${draft._id}_${session._id}`}>

      <DescriptiveCard
        key={`${draft._id}_jam_title`}
        id={`${draft._id}_jam_title`}
        // icon='icon-dice'
        label={`${draft.template.name} Jam Title:`}
        blurb={draft.title}
        image={draft.image}
        participantBtn={participantBtn}
        onClick={onClick}
        leader={leader}
        btnHidden={btnHidden}
        isShowing={isHidden[`${draft._id}_jam_title`] === false}
        />

      <DescriptiveCard
        key={`${draft._id}_jam_blurb`}
        id={`${draft._id}_jam_blurb`}
        label={`${draft.template.name} Jam Blurb:`}
        blurb={draft.blurb}
        participantBtn={participantBtn}
        onClick={onClick}
        leader={leader}
        btnHidden={btnHidden}
        isShowing={isHidden[`${draft._id}_jam_blurb`] === false}
      />

      {draft.parents.map((parent) => {
        return (
          <div key={`${parent._id}`}>
            <DescriptiveCard
              id={`${parent._id}_title`}
              icon="icon-dice"
              image={parent.image}
              label={`${parent.parentType} Title:`}
              blurb={parent.title || parent.name}
              participantBtn={participantBtn}
              onClick={onClick}
              leader={leader}
              btnHidden={btnHidden}
              isShowing={isHidden[`${parent._id}_title`] === false}
            />

            <DescriptiveCard
              id={`${parent._id}_blurb`}
              label={`${parent.parentType} Blurb:`}
              blurb={parent.prompt || parent.blurb}
              participantBtn={participantBtn}
              onClick={onClick}
              leader={leader}
              btnHidden={btnHidden}
              isShowing={isHidden[`${parent._id}_blurb`] === false}
            />
          </div>
        );
      })}

      {(session.output || (session.template && session.template.output) || []).map((prop, outputIndex) => {
        if (!/notes/i.test(prop.name)) {

          // console.log('DraftParentsGroup:session.output', prop)
          return (
            <CustomFieldsCard
              disabled={disabled}
              key={prop._id}
              id={prop._id}
              type={prop.type}
              label={prop.name}
              value={value || values[_.snakeCase(prop.slug)]}
              onChange={onChange(prop)}
            />
          )
        } else {

          // console.log('DraftParentGroup:NoteTextBox',session);
          if (!disabled && !endSession && leader) {
            return (
              <NoteTextBox
                  id={prop._id}
                  key={prop._id}
                  value={value || values[_.snakeCase(prop.slug)]}
                  onChange={onChange(prop)}
                  key={`output_${prop.slug}_${prop.type}`}
                  title={`Session Note ${session.index + 1}`}
                />
              )
            }
        }
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/DraftParentsGroup.js